import React from "react";

import { contactSort, phoneNumberSort } from "../../../util/sort.js";

export default function Contacts({ companyName, contacts }) {
  const openEmail = (email) => {
    document.location = `mailto:${email}`;
  };

  return (
    <div className="panel-body">
      <table
        id="contactInfo"
        className="table table-bordered"
        role="grid"
        summary={`List of Contacts for ${companyName}`}
      >
        <thead role="rowgroup">
          <tr role="row">
            <th id="position-head" role="columnheader">
              Position
            </th>
            <th id="name-head" role="columnheader">
              Name
            </th>
            <th id="email-head" role="columnheader">
              Email Address
            </th>
            <th id="phone-head" role="columnheader">
              Phone Numbers
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          {contacts
            .sort(contactSort)
            .map(({ sewperContactSeq, position, firstName, lastName, email, phoneNumbers, pmFlag, altPmFlag }) => (
              <tr key={sewperContactSeq} role="row">
                <th id={`${sewperContactSeq}-head`} role="rowheader" headers="position-head">
                  {pmFlag && position !== "Program Manager" && <div>Program Manager</div>}
                  {altPmFlag && position !== "Deputy Program Manager" && <div>Deputy Program Manager</div>}
                  {position}
                </th>
                <td role="gridcell" headers="row-head name-head">
                  {`${firstName} ${lastName}`}
                </td>
                <td role="gridcell" headers="row-head email-head">
                  <a className="clickable" onClick={() => openEmail(email)}>
                    {email}
                  </a>
                </td>
                <td role="gridcell" headers="row-head phone-head">
                  <ul className="list-unstyled">
                    {phoneNumbers.sort(phoneNumberSort).map(({ phone, typeFlag, contactPhoneSeq }) => (
                      <li key={contactPhoneSeq}>
                        {phone} {typeFlag !== "Phone" && <span>{typeFlag.toLowerCase()}</span>}
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
